import moment = require("moment");
import _ = require("lodash");
import { ComplianceRepo } from "@services/compliance.repo";
import { IOnInit } from "angular";
import { AuditPerformanceParameter } from "@app/compliance/models/auditPerformanceParameter ";
import { TableColumn } from "@models/components/tableColumn";
import { extractErrorMessage } from "@common/utils/errorUtils";

class ComplianceController implements IOnInit {
  public cashTransactions: Array<any>;
  public isLoadingCashTransactions;

  public toDate;
  public fromDate;
  public currentDate: Date;
  public cashTransactionsGridOptions;
  public displayCashTransactionCard = false;

  public performanceParameters: Array<any>;
  public isLoadingPerformanceParameters;
  public performanceParametersGridOptions;
  public displayPerformanceParameterCard = true;

  public tradingRestrictions: Array<any>;
  public isLoadingTradingRestrictions;
  public tradingRestrictionsGridOptions;
  public displayTradingRestrictionCard = true;

  public feeExclusions: Array<any>;
  public isLoadingFeeExclusions;
  public feeExclusionsGridOptions;
  public displayFeeExclusionCard = true;

  public clientFees: Array<any>;
  public isLoadingClientFees;
  public clientFeesGridOptions;
  public displayClientFeeCard = true;

  public cmodels: Array<any>;
  public isLoadingCmodels;
  public cmodelsGridOptions;
  public displayCmodelCard = true;

  public custodianReports: Array<any>;
  public isLoadingCustodianReports;
  public custodianReportsGridOptions;
  public displayCustodianReportCard = true;

  // Combined loading state for the card
  public isLoadingAllData: boolean = false;

  // Table column definitions
  public cashTransactionsColumns: TableColumn[];
  public performanceParametersColumns: TableColumn[];
  public tradingRestrictionsColumns: TableColumn[];
  public feeExclusionsColumns: TableColumn[];
  public clientFeesColumns: TableColumn[];
  public cmodelsColumns: TableColumn[];
  public custodianReportsColumns: TableColumn[];

  /** @ngInject */
  constructor(
    private $scope: angular.IScope,
    private complianceRepo: ComplianceRepo,
    private notifyjs,
    private $state: angular.ui.IStateService,
    private $window: angular.IWindowService,
    private $q: angular.IQService
  ) {
    this.currentDate = new Date();

    if (_.isEmpty(this.fromDate) || _.isEmpty(this.toDate)) {
      this.fromDate = new Date(
        moment(this.currentDate).subtract(1, "months").toString()
      ); //;
      this.toDate = this.currentDate;
    }

    this.cashTransactionsGridOptions = this.$scope[
      "cashTransactionsGridOptions"
    ] = {
      data: [],
      urlSync: false,
    };

    this.performanceParametersGridOptions = this.$scope[
      "performanceParametersGridOptions"
    ] = {
      data: [],
      urlSync: false,
    };

    this.tradingRestrictionsGridOptions = this.$scope[
      "tradingRestrictionsGridOptions"
    ] = {
      data: [],
      urlSync: false,
    };

    this.feeExclusionsGridOptions = this.$scope["feeExclusionsGridOptions"] = {
      data: [],
      urlSync: false,
    };

    this.clientFeesGridOptions = this.$scope["clientFeesGridOptions"] = {
      data: [],
      urlSync: false,
    };
    this.cmodelsGridOptions = this.$scope["cmodelsGridOptions"] = {
      data: [],
      urlSync: false,
    };

    this.custodianReportsGridOptions = this.$scope["custodianReportsGridOptions"] = {
      data: [],
      urlSync: false,
    };

    // Initialize table columns
    this.initializeTableColumns();
  }

  initializeTableColumns = () => {
    // Cash Transactions columns
    this.cashTransactionsColumns = [
      { key: 'dateModified', label: 'Date Modified', type: 'text' },
      { key: 'clientName', label: 'Client', type: 'html' },
      { key: 'accountNumber', label: 'Portfolio', type: 'text' },
      { key: 'modifiedBy', label: 'Modified By', type: 'text' },
      { key: 'type', label: 'Type', type: 'text' },
      { key: 'transactionDate', label: 'Transaction Date', type: 'text' },
      { key: 'cashAccountNumber', label: 'Cash Account', type: 'text' },
      { key: 'amountDebited', label: 'Amount Debited', type: 'currency', currency: 'MUR' },
      { key: 'amountCredited', label: 'Amount Credited', type: 'currency', currency: 'MUR' }
    ];

    // Performance Parameters columns
    this.performanceParametersColumns = [
      { key: 'dateModified', label: 'Date Modified', type: 'text' },
      { key: 'clientName', label: 'Client', type: 'html' },
      { key: 'accountNumber', label: 'Portfolio', type: 'html' },
      { key: 'type', label: 'Type', type: 'html' },
      { key: 'performanceDate', label: 'Date', type: 'text' },
      { key: 'openingBalance', label: 'Opening Balance', type: 'currency', currency: 'MUR' },
      { key: 'closingBalance', label: 'Closing Balance', type: 'currency', currency: 'MUR' },
      { key: 'totalDebitAmount', label: 'Debit', type: 'currency', currency: 'MUR' },
      { key: 'totalCreditAmount', label: 'Credit', type: 'currency', currency: 'MUR' },
      { key: 'performance', label: 'Performance (%)', type: 'percentage' }
    ];

    // Trading Restrictions columns
    this.tradingRestrictionsColumns = [
      { key: 'dateModified', label: 'Date Modified', type: 'text' },
      { key: 'clientName', label: 'Client', type: 'html' },
      { key: 'accountNumber', label: 'Portfolio', type: 'text' },
      { key: 'security', label: 'Security', type: 'html' },
      { key: 'modifiedBy', label: 'Modified By', type: 'text' },
      { key: 'restrictionType', label: 'Restriction Type', type: 'text' },
      { key: 'enabled', label: 'Active', type: 'boolean' }
    ];

    // Fee Exclusions columns
    this.feeExclusionsColumns = [
      { key: 'dateModified', label: 'Date Modified', type: 'text' },
      { key: 'clientName', label: 'Client', type: 'html' },
      { key: 'accountNumber', label: 'Portfolio', type: 'text' },
      { key: 'security', label: 'Security', type: 'html' },
      { key: 'modifiedBy', label: 'Modified By', type: 'html' },
      { key: 'exclusionType', label: 'Type', type: 'text' },
      { key: 'exclude', label: 'Exclude', type: 'text' },
      { key: 'fromDate', label: 'Start', type: 'text' },
      { key: 'toDate', label: 'Ends', type: 'text' },
      { key: 'isActive', label: 'Active', type: 'boolean' }
    ];

    // Client Fees columns
    this.clientFeesColumns = [
      { key: 'dateModified', label: 'Date Modified', type: 'text' },
      { key: 'clientName', label: 'Client', type: 'html' },
      { key: 'portfolios', label: 'Portfolios', type: 'html' },
      { key: 'feeTypeName', label: 'Fee Type', type: 'text' },
      { key: 'modifiedBy', label: 'Modified By', type: 'html' },
      { key: 'fromDate', label: 'Start', type: 'text' },
      { key: 'toDate', label: 'Ends', type: 'text' },
      { key: 'comment', label: 'Comment', type: 'text' }
    ];

    // C-Models columns
    this.cmodelsColumns = [
      { key: 'dateCreated', label: 'Date Modified', type: 'text' },
      { key: 'name', label: 'Created By', type: 'text' },
      { key: 'totalMarketValue', label: 'Total Market Value', type: 'currency', currency: 'MUR' },
      { key: 'numberOfSecurities', label: 'No. of Securities', type: 'text' }
    ];

    // Custodian Reports columns
    this.custodianReportsColumns = [
      { key: 'dateModified', label: 'Date Modified', type: 'text' },
      { key: 'clientName', label: 'Client', type: 'html' },
      { key: 'accountNumber', label: 'Portfolio', type: 'text' },
      { key: 'name', label: 'Report Name', type: 'text' },
      { key: 'reportDate', label: 'Report Date', type: 'text' },
      { key: 'currency', label: 'Currency', type: 'text' },
      { key: 'addedBy', label: 'Added By', type: 'text' },
      { key: 'modifiedBy', label: 'Modified By', type: 'text' },
      { key: 'approvedBy', label: 'Approved By', type: 'text' },
      { key: 'approved', label: 'Approved', type: 'boolean' },
      { key: 'isActive', label: 'Active', type: 'boolean' },
      { key: 'fileName', label: 'File Name', type: 'text' },
      { key: 'auditAction', label: 'Action', type: 'text' }
    ];
  }

  $onInit = () => {
    this.updateData();
  };

  fromDateChanged = () => {
    if (this.fromDate < this.toDate) {
      this.updateData();
    }
  };

  toDateChanged = () => {
    this.updateData();
  };

  updateData = () => {
    this.isLoadingAllData = true;
    
    // Fetch all data in parallel using Angular's $q.all
    const allPromises = this.$q.all([
      this.getCashTransactionsPromise(),
      this.getPerformanceParametersPromise(),
      this.getTradingRestrictionsPromise(),
      this.getFeeExclusionsPromise(),
      this.getClientFeesPromise(),
      this.getCModelsPromise(),
      this.getCustodianReportsPromise()
    ]);
    
    allPromises.finally(() => {
      this.isLoadingAllData = false;
    });
  };

  getAllAuditData = () => {
    this.fromDate = moment("2018-01-01").format("YYYY-MM-DD");
    this.toDate = this.currentDate;
    this.updateData();
  };

  getCashTransactionsPromise = (): angular.IPromise<void> => {
    this.isLoadingCashTransactions = true;
    return this.complianceRepo
      .getCashTransactions(this.fromDate, this.toDate)
      .then((res) => {
        const rawData = res.data as Array<any>;
        this.cashTransactions = rawData.map(item => ({
          ...item,
          dateModified: this.getLocalDateTime(item.dateModified),
          clientName: `${item.clientName}<br><span class="table-subtitle">${item.clientNumber}</span>`,
          modifiedBy: item.isAdhoc && !item.isOverridden ? item.addedBy : 
                     item.isOverridden ? item.overriddenBy : '',
          type: item.isAdhoc && !item.isOverridden ? 'Ad-hoc' : 
                item.isOverridden ? 'Overridden' : '',
          transactionDate: item.transactionDate ? moment(item.transactionDate).format('DD-MM-YYYY') : '',
          amountDebited: item.amountDebited || 0,
          amountCredited: item.amountCredited || 0,
          currency: item.currency || 'MUR'
        }));
        this.cashTransactionsGridOptions.data = this.cashTransactions;
        this.displayCashTransactionCard = true;
      })
      .catch((err) => {
        this.notifyjs(
          "Failed to load cash transactions for the selected date " + err.data
        );
        throw err;
      })
      .finally(() => {
        this.isLoadingCashTransactions = false;
      });
  };

  getCashTransactions = () => {
    this.getCashTransactionsPromise();
  };

  getLocalDateTime = (utcDate) => {
    return moment.utc(utcDate).local().format("DD-MM-YYYY HH:mm:ss");
  };

  goToClient = (params: { item: any }) => {
    if (params && params.item && params.item.clientNumber) {
      var url = this.$state.href("root.portfolioManagement.clients.portfolio", {
        clientNumber: params.item.clientNumber,
      });
      this.$window.open(url, "_blank");
    }
  };

  getCashTransactionHistory = (item) => {
    if (item.transactionHistory == null) {
      this.complianceRepo
        .getCashTransactionHistory(item.id)
        .then((res) => {
          item.transactionHistory = res.data as Array<any>;
        })
        .catch((err) => {
          this.notifyjs(
            "Could not find history for the selected cash transaction " +
              err.data
          );
        });
    }
  };

  getPerformanceParametersPromise = (): angular.IPromise<void> => {
    this.isLoadingPerformanceParameters = true;
    return this.complianceRepo
      .getPerformanceParameters(this.fromDate, this.toDate, "MUR")
      .then((res) => {
        const rawData = res.data as Array<AuditPerformanceParameter>;
        this.performanceParameters = rawData.map(item => {
          let typeText = '';
          if (item.lockedOn > item.overriddenOn) {
            typeText = `Locked by - ${item.lockedBy}<br><span class="table-subtitle">${this.getLocalDateTime(item.lockedOn)}</span>`;
          } else if (item.overriddenOn > item.lockedOn) {
            typeText = `Overridden by - ${item.overriddenBy}<br><span class="table-subtitle">${this.getLocalDateTime(item.overriddenOn)}</span>`;
          } else if (item.isOpeningBalanceEdited) {
            typeText = `Opening balance edited by - ${item.openingBalanceEditedBy}<br><span class="table-subtitle">${this.getLocalDateTime(item.openingBalanceEditedOn)}</span>`;
          } else if (item.isClosingBalanceEdited) {
            typeText = `Closing balance edited by - ${item.closingBalanceEditedBy}<br><span class="table-subtitle">${this.getLocalDateTime(item.closingBalanceEditedOn)}</span>`;
          }

          return {
            ...item,
            dateModified: this.getLocalDateTime(item.dateModified),
            clientName: `${item.clientName}<br><span class="table-subtitle">${item.clientNumber}</span>`,
            accountNumber: `${item.accountNumber}<br><span class="table-subtitle">${this.getLocalityText(item.locality)}</span>`,
            type: typeText,
            performanceDate: item.performanceDate ? moment(item.performanceDate).format('DD-MM-YYYY') : '',
            performance: this.getPercentageValue(item.performance),
            currency: item.currency || 'MUR'
          };
        });
        this.performanceParametersGridOptions.data = this.performanceParameters;
        this.displayPerformanceParameterCard = true;
      })
      .catch((err) => {
        this.notifyjs("Failed to load performance values " + extractErrorMessage(err));
        throw err;
      })
      .finally(() => {
        this.isLoadingPerformanceParameters = false;
      });
  };

  getPerformanceParameters = () => {
    this.getPerformanceParametersPromise();
  };

  getLocalityText = (locality) => {
    return locality == 0
      ? "Local"
      : locality == 1
      ? "International"
      : locality == "2"
      ? "Combined"
      : "";
  };

  getBoolToText = (val) => {
    return val ? "Yes" : "No";
  };

  getPercentageValue = (performance) => {
    return +(performance * 100).toFixed(2);
  };

  getPerformanceParameterHistory = (performanceParamater) => {
    if (performanceParamater.performanceHistory == null) {
      this.complianceRepo
        .getPerformanceParametersHistory(
          performanceParamater.id,
          performanceParamater.portfolioId,
          performanceParamater.performanceDate
        )
        .then((res) => {
          performanceParamater.performanceHistory = res.data as Array<any>;
        })
        .catch((err) => {
          this.notifyjs("Failed to get performance history " + extractErrorMessage(err));
        });
    }
  };

  getTradingRestrictionsPromise = (): angular.IPromise<void> => {
    this.isLoadingTradingRestrictions = true;
    return this.complianceRepo
      .getTradingRestrictions(this.fromDate, this.toDate)
      .then((res) => {
        const rawData = res.data as Array<any>;
        this.tradingRestrictions = rawData.map(item => ({
          ...item,
          dateModified: this.getLocalDateTime(item.dateModified),
          clientName: `${item.clientName}<br><span class="table-subtitle">${item.clientNumber}</span>`,
          security: `${this.getRestrictionDescription(item)}<br><span class="table-subtitle">${item.isin}</span>`,
          modifiedBy: item.dateCreated > item.modifiedOn ? 
                     `Added by : ${item.createdBy}` : 
                     `Modified By : ${item.modifiedBy}`,
          restrictionType: this.getRestrictionTypeText(item),
          enabled: item.enabled
        }));
        this.tradingRestrictionsGridOptions.data = this.tradingRestrictions;
        this.displayTradingRestrictionCard = true;
      })
      .catch((err) => {
        this.notifyjs("Failed to load trading restrictions " + extractErrorMessage(err));
        throw err;
      })
      .finally(() => {
        this.isLoadingTradingRestrictions = false;
      });
  };

  getTradingRestrictions = () => {
    this.getTradingRestrictionsPromise();
  };

  getRestrictionTypeText = (restriction) => {
    if (restriction.noBuy && restriction.noSell) {
      return "Can not be bought or sold";
    }

    if (restriction.noBuy) {
      return "Can not be bought";
    }

    if (restriction.noSell) {
      return "Can not be sold";
    }

    if (restriction.percentageOfPortfolio) {
      return `Must be between ${restriction.minPortfolio}% and ${restriction.maxPortfolio}% of overall portfolio`;
    }

    return "No trade restriction";
  };

  getTradingRestrictionHistory = (restriction) => {
    if (restriction.restrictionHistory == null) {
      this.complianceRepo
        .getTradingRestrictionHistory(restriction.id)
        .then((res) => {
          restriction.restrictionHistory = res.data as Array<any>;
        })
        .catch((err) => {
          this.notifyjs("Failed to load restriction history " + extractErrorMessage(err));
        });
    }
  };

  getFeeExclusionsPromise = (): angular.IPromise<void> => {
    this.isLoadingFeeExclusions = true;
    return this.complianceRepo
      .getFeeExclusions(this.fromDate, this.toDate)
      .then((res) => {
        const rawData = res.data as Array<any>;
        this.feeExclusions = rawData.map(item => ({
          ...item,
          dateModified: this.getLocalDateTime(item.dateModified),
          clientName: `${item.clientName}<br><span class="table-subtitle">${item.clientNumber}</span>`,
          security: item.isCashExclusion ? 
                   `Cash Exclusion<br><span class="table-subtitle">${item.cashCurrency || ''}</span>` :
                   `${item.description}<br><span class="table-subtitle">${item.isin}</span>`,
          modifiedBy: item.modifiedOn == null ? 
                     `Added By<br>${item.addedBy}` : 
                     `Modified By<br>${item.modifiedBy}`,
          exclusionType: item.isCashExclusion ? 'Cash' : 'Security',
          exclude: item.isCashExclusion ? 
                  `${item.cashCurrency || ''} ${item.cashAmount || 0}` :
                  (item.excludeMarketValue ? 'Market Value' : (item.marketValue || 0)),
          fromDate: item.fromDate ? moment(item.fromDate).format('DD-MM-YYYY') : '',
          toDate: item.toDate ? moment(item.toDate).format('DD-MM-YYYY') : '∞',
          currency: item.currency || 'MUR'
        }));
        this.feeExclusionsGridOptions.data = this.feeExclusions;
        this.displayFeeExclusionCard = true;
      })
      .catch((err) => {
        this.notifyjs("Failed to load fee exclusions " + extractErrorMessage(err));
        throw err;
      })
      .finally(() => {
        this.isLoadingFeeExclusions = false;
      });
  };

  getFeeExclusions = () => {
    this.getFeeExclusionsPromise();
  };

  getFeeExclusionHistory = (feeExclusion) => {
    if (feeExclusion.feeExclusionHistory == null) {
      this.complianceRepo
        .getFeeExclusionHistory(feeExclusion.id)
        .then((res) => {
          feeExclusion.feeExclusionHistory = res.data as Array<any>;
        })
        .catch((err) => {
          this.notifyjs(
            "Failed to get history for selected fee exclusion " + err.data
          );
        });
    }
  };

  getClientFeesPromise = (): angular.IPromise<void> => {
    this.isLoadingClientFees = true;
    return this.complianceRepo
      .getClientFees(this.fromDate, this.toDate)
      .then((res) => {
        const rawData = res.data as Array<any>;
        this.clientFees = rawData.map(item => ({
          ...item,
          dateModified: this.getLocalDateTime(item.dateModified),
          clientName: `${item.clientName}<br><span class="table-subtitle">${item.clientNumber}</span>`,
          portfolios: item.accountNumbers ? item.accountNumbers.join('<br>') : '',
          feeTypeName: item.feeTypeName + (item.value != 0 ? ` ${this.getPercentageValue(item.value)} %` : ''),
          modifiedBy: item.modifiedOn == null || item.modifiedOn < item.dateAdded ? 
                     `Added By<br>${item.addedBy}` : 
                     `Modified By<br>${item.modifiedBy}`,
          fromDate: item.fromDate ? moment(item.fromDate).format('DD-MM-YYYY') : '',
          toDate: item.toDate ? moment(item.toDate).format('DD-MM-YYYY') : '∞'
        }));
        this.clientFeesGridOptions.data = this.clientFees;
        this.displayClientFeeCard = true;
      })
      .catch((err) => {
        this.notifyjs("Failed to load client fees " + extractErrorMessage(err));
        throw err;
      })
      .finally(() => {
        this.isLoadingClientFees = false;
      });
  };

  getClientFees = () => {
    this.getClientFeesPromise();
  };

  getClientFeeHistory = (clientFee) => {
    if (clientFee.clientFeeHistory == null) {
      this.complianceRepo
        .getClientFeeHistory(clientFee.portfolioFeeId)
        .then((res) => {
          clientFee.clientFeeHistory = res.data as Array<any>;
        })
        .catch((err) => {
          this.notifyjs(
            "Failed to get history for selected client fee " + err.data
          );
        });
    }
  };

  getCModelsPromise = (): angular.IPromise<void> => {
    this.isLoadingCmodels = true;
    return this.complianceRepo
      .getCModels(this.fromDate, this.toDate)
      .then((res) => {
        const rawData = res.data as Array<any>;
        this.cmodels = rawData.map(item => ({
          ...item,
          dateCreated: this.getLocalDateTime(item.dateCreated),
          totalMarketValue: this.getCmodelTotalMarketValue(item),
          numberOfSecurities: item.items ? item.items.length : 0,
          currency: 'MUR'
        }));
        this.displayCmodelCard = true;
      })
      .catch((err) => {
        this.notifyjs("Could not get Cmodels " + extractErrorMessage(err));
        throw err;
      })
      .finally(() => {
        this.isLoadingCmodels = false;
      });
  };

  getCModels = () => {
    this.getCModelsPromise();
  };

  goToCmodel = (params: { item: any }) => {
    var url = this.$state.href("root.cmodel.mauritius");
    this.$window.open(url, "_blank");
  };

  getCmodelTotalMarketValue = (cmodel) => {
    return cmodel.items.reduce((prev, next) => {
      return prev + next.quantity * next.price;
    }, 0);
  };

  getRestrictionDescription = (restriction) => {
    if (restriction.securityName !== "") {
      return restriction.description;
    } else {
      return restriction.assetClassName;
    }
  };

  getCustodianReportsPromise = (): angular.IPromise<void> => {
    this.isLoadingCustodianReports = true;
    return this.complianceRepo
      .getCustodianReports(this.fromDate, this.toDate)
      .then((res) => {
        const rawData = res.data as Array<any>;
        this.custodianReports = rawData.map(item => {
          // Use DateModified if available, otherwise use AuditDate
          const dateModified = item.dateModified ? item.dateModified : item.auditDate;
          // Handle both camelCase and PascalCase property names
          const accountNumber = item.accountNumber || item.AccountNumber || '';
          return {
            ...item,
            dateModified: this.getLocalDateTime(dateModified),
            auditDate: this.getLocalDateTime(item.auditDate),
            clientName: item.clientName ? `${item.clientName}<br><span class="table-subtitle">${item.clientNumber}</span>` : '',
            accountNumber: accountNumber,
            reportDate: item.reportDate ? moment(item.reportDate).format('DD-MM-YYYY') : '',
            modifiedBy: item.modifiedBy || '',
            approvedBy: item.approvedBy || '',
            approved: item.approved || false,
            isActive: item.isActive || false,
            fileName: item.fileName || '',
            auditAction: item.auditAction || ''
          };
        });
        this.custodianReportsGridOptions.data = this.custodianReports;
        this.displayCustodianReportCard = true;
      })
      .catch((err) => {
        this.notifyjs("Failed to load custodian reports " + extractErrorMessage(err));
        throw err;
      })
      .finally(() => {
        this.isLoadingCustodianReports = false;
      });
  };

  getCustodianReports = () => {
    this.getCustodianReportsPromise();
  };
}

export const compliance: angular.IComponentOptions = {
  template: require("./compliance.component.html"),
  controller: ComplianceController,
};



// WEBPACK FOOTER //
// ./src/app/compliance/compliance.component.ts